import { Constants } from '@pwc/pwc-deals-web-common';

export class ActivityService {
  constructor(threshold) {
    this.threshold = threshold;
    this.secondsSinceLastActive = 0;
    this.intervalID = null;
    this.userActive = true;
    this.registeredEvents = [];
    this.resetTimer = this.resetTimer.bind(this);
    this.clearActivityTimer = this.clearActivityTimer.bind(this);
    this.startActivityTimer = this.startActivityTimer.bind(this);
  }

  clearActivityTimer() {
    if (this.intervalID) {
      clearInterval(this.intervalID);
      this.intervalID = null;
    }
  }

  resetTimer() {
    this.secondsSinceLastActive = 0;
  }

  isUserActive() {
    return this.userActive;
  }

  registerEvents(events) {
    events.forEach((eventName) => {
      window.addEventListener(eventName, (e) => this.resetTimer(e), true);
      this.registeredEvents.push(eventName);
    });
  }

  startActivityTimer() {
    this.intervalID = setInterval(() => {
      this.secondsSinceLastActive += 1;
      if (this.secondsSinceLastActive > this.threshold) {
        this.userActive = false;
      }
    }, 1000);
  }
}

const userActivityService = new ActivityService(
  Constants.USER_INACTIVE_TIMEOUT
);
userActivityService.registerEvents(Constants.USER_ACTIVITY_DOM_EVENTS);
userActivityService.startActivityTimer();

export default userActivityService;
